export const i18n = {
    defaultLocale: 'en-US',
    locales: ['en-US', 'zh-HK', 'zh-CN'],
    // locales: ['en-US', 'zh-HK'],
    defaultNameSpace: 'common',
} as const;

export type Locale = (typeof i18n)['locales'][number];
